import { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";
import { useParams } from "react-router-dom";
import logoHeader from "../../assets/logo.png";
// Formulario legacy: ModalContacto / Formulario (sin uso en CTAs; recuperable)
import { getFirestore } from "../../config/firebase";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import { collection, docs, getDocs } from "firebase/firestore";
import { buildUtmQueryString, saveUtmParams } from "../../config/whatsappConfig";

const TIPOS_VALIDOS = ["todos", "convencional", "plan", "preventa", "adjudicados"];

const Header = ({ bg, vMarca, vModelo }) => {
  const [vehicles, setVehicles] = useState([]);
  const db = getFirestore();

  // useEffect(() => {
  //   const vehicles = db.collection("jeep");
  //   vehicles.get().then((querySnapshot) => {
  //     setVehicles(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  //   });

  // }, []);

  useEffect(() => {
    const cargarVehiculos = async () => {
      // Verificar si los datos ya están en localStorage
      const datosLocales = sessionStorage.getItem("vehicles-jeep");
      if (datosLocales) {
        // Parsear los datos de localStorage y establecerlos en el estado
        setVehicles(JSON.parse(datosLocales));
      } else {
        // Si no están en localStorage, obtenerlos de Firebase
        try {
          const querySnapshot = await db.collection("jeep").get();
          const arrayVehicles = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
          setVehicles(arrayVehicles);
          // Almacenar los datos en localStorage
          sessionStorage.setItem("vehicles-jeep", JSON.stringify(arrayVehicles));
        } catch (error) {
          console.log(error);
        }
      }
    };

    // Llamar a la función para cargar datos
    cargarVehiculos();
  }, [db]);

  const { openConsultaForm } = useWhatsAppConsulta();

  const utms = buildUtmQueryString();

  const [tipoSearch, setTipoSearch] = useState("todos");
  const [tipoToUse, setTipoToUse] = useState("todos");
  const [filtrados, setFiltrados] = useState(vehicles);

  let { tipo } = useParams();

  useEffect(() => {
    setTipoToUse(tipo === undefined || !TIPOS_VALIDOS.includes(tipo) ? "todos" : tipo);
  }, [tipo]);

  useEffect(() => {
    setTipoSearch(tipoToUse);
  }, [tipoToUse]);

  const scrollToModelos = () => {
    saveUtmParams();
    scroller.scrollTo("scroll-click", { smooth: true, duration: 500 });
  };

  //FILTRAR LOS VEHICULOS
  useEffect(() => {
    if (tipoSearch === "preventa") {
      setFiltrados(vehicles.filter((item) => item.preventa.habilitado === true));
    }

    if (tipoSearch === "plan") {
      setFiltrados(vehicles.filter((item) => item.plan.habilitado === true));
    }

    if (tipoSearch === "convencional") {
      setFiltrados(vehicles.filter((item) => item.convencional.habilitado === true));
    }

    if (tipoSearch === "todos") {
      setFiltrados(vehicles);
    }
  }, [tipoSearch, vehicles]);

  const handlePedirPresupuesto = () => {
    window.dataLayer.push({
      event: "solicitud_presupuesto",
    });
    openConsultaForm();
  };

  return (
    <Container fluid className="header">
      <Container>
        <Row className="row-header">
          <Col md={6} xs={12} className="text-sm-start text-center pt-3">
            <Link to={`/${utms}`}>
              <img src={logoHeader} alt="Montironi Jeep" className="img-fluid" />
            </Link>
          </Col>
          <Col
            md={6}
            xs={12}
            className="text-sm-start text-center pt-4 justify-content-md-end justify-content-center d-md-flex d-none"
          >
            <button
              type="button"
              className="link-header px-sm-3 border-0 bg-transparent"
              style={{ cursor: "pointer" }}
              onClick={scrollToModelos}
            >
              Modelos
            </button>

            <Button className="btn-blue ms-md-4" onClick={() => handlePedirPresupuesto()}>
              Pedir presupuesto
            </Button>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Header;
